import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import SupermarketTabs from "../components/SupermarketTabs";
import ProductSection from "../components/ProductSection";
import Footer from "../components/Footer";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { fetchActowizProducts, fetchActowizFeatures, fetchActowizTopDeals } from "../store/actowiz/actowizSlice";

const sections = [
  "Today's Top Deals",
  "Features Products",
  "Tesco Products",
  "Morrisons Products",
  "ASDA Products",
  "Sainsbury's Products",
];

function FemtyzHome({ onOpenAuth, onOpenMenu }) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const byPlatform = useAppSelector((s) => s.actowiz.byPlatform);
  const features = useAppSelector((s) => s.actowiz.features);
  const topDeals = useAppSelector((s) => s.actowiz.topDeals);
  const pageSize = 10;

  useEffect(() => {
    dispatch(
      fetchActowizProducts({
        platform: "tesco",
        start: 0,
        offset: pageSize,
        mode: "replace",
      })
    );
    dispatch(
      fetchActowizProducts({
        platform: "morrison",
        start: 0,
        offset: pageSize,
        mode: "replace",
      })
    );
    dispatch(
      fetchActowizProducts({
        platform: "asda",
        start: 0,
        offset: pageSize,
        mode: "replace",
      })
    );
    dispatch(
      fetchActowizProducts({
        platform: "sainsbury",
        start: 0,
        offset: pageSize,
        mode: "replace",
      })
    );
    dispatch(fetchActowizFeatures({ start: 0, offset: pageSize, mode: "replace" }));
    dispatch(fetchActowizTopDeals({ start: 0, offset: pageSize, mode: "replace" }));
  }, [dispatch]);

  const combined = useMemo(() => {
    const a = [
      ...(byPlatform?.tesco || []),
      ...(byPlatform?.morrison || []),
      ...(byPlatform?.asda || []),
      ...(byPlatform?.sainsbury || []),
    ];
    return a;
  }, [byPlatform]);

  return (
    <div className="min-h-screen bg-slate-100 text-slate-900">
      <Header onOpenAuth={onOpenAuth} onOpenMenu={onOpenMenu} />

      <main className="mx-auto flex max-w-8xl gap-6 px-4 py-6 md:px-6">
        <Sidebar />

        <section className="flex-1 space-y-8">
          <SupermarketTabs />

          {sections.map((section, idx) => (
           <ProductSection
           key={section}
           title={section}
           sectionIdx={idx}
           initialLimit={5}
           onViewMore={
             section === "Today's Top Deals"
               ? () => navigate("/top-deals")
               : section === "Tesco Products"
               ? () => navigate("/platform/tesco")
               : section === "Features Products"
               ? () => navigate("/features")
               : section === "Morrisons Products"
               ? () => navigate("/platform/morrison")
               : section === "ASDA Products"
               ? () => navigate("/platform/asda")
               : section === "Sainsbury's Products"
               ? () => navigate("/platform/sainsbury")
               : undefined
           }
           products={
             section === "Today's Top Deals"
               ? topDeals || []
               : section === "Tesco Products"
               ? byPlatform?.tesco || []
               : section === "Features Products"
               ? features || []
               : section === "Morrisons Products"
               ? byPlatform?.morrison || []
               : section === "ASDA Products"
               ? byPlatform?.asda || []
               : section === "Sainsbury's Products"
               ? byPlatform?.sainsbury || []
               : combined
           }
         />
          ))}
        </section>
      </main>

      <Footer />
    </div>
  );
}

export default FemtyzHome;